import { supabase } from '@/lib/supabase'

export type InOutState = {
  opportunityId: number
  isIn: boolean
}

export type InOutMap = Record<string, boolean>

export async function fetchInOutMap(opportunityIds: number[]): Promise<InOutMap> {
  if (!opportunityIds.length) return {}
  const uniqueIds = Array.from(new Set(opportunityIds.map((id) => Number(id)).filter((id) => Number.isFinite(id))))
  if (!uniqueIds.length) return {}

  const { data, error } = await supabase.rpc('get_user_inout_map', {
    p_ids: uniqueIds,
  })

  if (error) {
    // Fail-open: apenas loga e retorna vazio
    // eslint-disable-next-line no-console
    console.error('[in-out] fetchInOutMap error', error)
    return {}
  }

  const map: InOutMap = {}
  ;(data || []).forEach((row: any) => {
    const id = Number(row.opportunity_id)
    if (!Number.isFinite(id)) return
    map[String(id)] = !!row.is_in
  })
  return map
}

export async function setInOut(opportunityId: number, isIn: boolean): Promise<InOutState> {
  const { data, error } = await supabase.rpc('set_opportunity_inout', {
    p_opportunity_id: opportunityId,
    p_is_in: isIn,
  })
  if (error) {
    // eslint-disable-next-line no-console
    console.error('[in-out] setInOut error', { opportunityId, isIn, error })
    throw error
  }
  const row = Array.isArray(data) && data.length > 0 ? data[0] : null
  return {
    opportunityId,
    isIn: row ? !!row.is_in : isIn,
  }
}
